import { HiChevronLeft } from "react-icons/hi";
import CloseDetailPage from "../../../components/CloseComponent/CloseDetailPage";
import DetailWrapper from "../../../components/detailWrapper";
import { useNavigate } from "react-router";
import OriginInputCustom from "../../../components/InputComponents/originInputCustom";
import { Button } from "semantic-ui-react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useState } from "react";

const PersonalData = () => {
  const { t } = useTranslation();
  const i18n = (key) => t(`settings.${key}`);
  const i18n_common = (key) => t(`common.${key}`);

  const navigate = useNavigate();

  const memberData = useSelector((state) => state.isMemberInfo);

  const { blank_name, memId, birth, contact_address } = memberData;

  const personalData = [
    {
      name: "real_name",
      label: i18n("form.realName"),
      type: "text",
      value: blank_name,
    },
    {
      name: "memId",
      label: i18n("form.memId"),
      type: "text",
      value: memId,
    },
    {
      name: "birthday",
      label: i18n("form.birthday"),
      type: "text",
      value: birth || "-",
    },

    // {
    //   name: "contact_address",
    //   label: i18n("form.contactAddress"),
    //   type: "text",
    //   value: contact_address,
    // },
  ];

  return (
    <DetailWrapper
      closeAnimate
      wrapperClassName={`h-full w-full md:absolute fixed top-0 left-0 max-h-full z-[1] bg-gradient-to-br`}
    >
      <CloseDetailPage
        hasPrev={
          <HiChevronLeft
            className="cursor-pointer"
            onClick={() => navigate("..")}
          />
        }
        title={i18n("personalInformation")}
      />
      <article className="flex flex-col gap-[10px] p-[15px]">
        {personalData.map((item, index) => {
          return (
            <div>
              <span className="text-sm text-transaction-text dark:text-base-light-white font-medium">
                {item.label}
              </span>
              <OriginInputCustom
                {...item}
                value={item.value}
                name={item.name}
                type={item.type}
                disabled
              />
            </div>
          );
        })}
        {/* <Button
          type="submit"
          content={i18n_common("SAVE")}
          size="xl"
          className="!bg-main-color !text-white !py-[17px] !mt-[20px]"
        ></Button> */}
      </article>
    </DetailWrapper>
  );
};

export default PersonalData;
